import { useEffect } from 'react';
import { useAuth } from '@/hooks';
import { useKFlags } from './use-k-flags';

export const useIntercom = () => {
  const { getAuth, currUser } = useAuth();
  const { ats_enabled } = useKFlags();

  useEffect(() => {
    if (!import.meta.env.VITE_INTERCOM_WORKSPACE_ID) return;
    if (ats_enabled) return;

    const accountName = window?.location?.hostname.split('.')[0];
    if (!document.getElementById('intercom-script')) {
      const intercomScript = document.createElement('script');
      intercomScript.id = 'intercom-script';
      // Intercom widget script
      intercomScript.innerText = `(function () { var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/${import.meta.env.VITE_INTERCOM_WORKSPACE_ID}'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } } })();`;
      document.body.appendChild(intercomScript);
    }
    // If the user is logged in, show the widget with pre-loaded user details.
    if (getAuth()) {
      window?.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: import.meta.env.VITE_INTERCOM_WORKSPACE_ID,
        name: currUser?.first_name,
        email: currUser?.email,
        company: {
          company_id: accountName, // Passing the same value as below as id and name are mandatory.
          name: accountName,
        },
        created_at: Date.parse(currUser?.created_at) || undefined,
        vertical_padding: 50,
        horizontal_padding: 20,
      });
    }
    // If the user is logged out/anonymous, shutdown the widget first to refresh it
    // and load the widget with no user details.
    else {
      window?.Intercom('shutdown');
      window?.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: import.meta.env.VITE_INTERCOM_WORKSPACE_ID,
        company: {
          company_id: accountName, // Passing the same value as below as id and name are mandatory.
          name: accountName,
        },
        vertical_padding: 50,
        horizontal_padding: 20,
      });
    }
  }, [currUser, getAuth]); // eslint-disable-line react-hooks/exhaustive-deps
};
